module.exports = __webpack_public_path__ + "img/cicchetti-gold_0.5e88fc49.jpg";